import { Field, FieldType, Key } from '@bybeam/platform-types';

export enum FieldContext {
  Base,
  Complex,
  Panel,
}

export function makeSkipIndicator(key: Key): Field {
  return { type: FieldType.Checkbox, key: `${key}.skipped` } as Field;
}
